import { useProfileQuery } from 'v2/pages/settings/queries'
import { getEmbedSession, isEmbedMode } from 'v2/shared/utils/embed-session'
import { useFeatureFlags } from './use-feature-flags'

const LIVEKIT_AUTO_ENABLE_CUTOFF = '2026-04-27'

export const useLivekitEnabled = () => {
  const { isLivekitEnabled: flagEnabled, isInitialData: isFeatureFlagsLoading } = useFeatureFlags()
  const { data: profile, isLoading: isProfileLoading } = useProfileQuery()

  // Embed has no profile query; the session carries org_created_at (from session/me).
  const orgCreatedAt = isEmbedMode()
    ? getEmbedSession()?.org_created_at
    : profile?.organizations?.[0]?.org_created_at
  // org_created_at format: "YYYY-MM-DD HH:mm:ss". Fixed-width date prefix lets us
  // string-compare against a YYYY-MM-DD cutoff without timezone-parsing ambiguity.
  const isPostCutoffOrg = orgCreatedAt ? orgCreatedAt >= LIVEKIT_AUTO_ENABLE_CUTOFF : false

  return {
    isLivekitEnabled: flagEnabled || isPostCutoffOrg,
    isLoading: isFeatureFlagsLoading || (!flagEnabled && isProfileLoading),
  }
}
